import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import InputSearch from '@/components/common/Input/InputSearch/InputSearch';
import InputSelect from '@/components/common/Input/InputSelect/InputSelect';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ConferenceList from '@/components/Conference/ConferenceList/ConferenceList';
import useIsMobile from '@/hooks/useIsMobile';
import { useLocation, useNavigate } from 'react-router-dom';
import * as S from './style';
import infoBanner from '@/assets/img/banner/news.png';
import defaultImg from '@/assets/img/defaulmg.jpg';
import BoardTable from '@/components/common/Table/BoardTable/BoardTable';
import TabList from '@/components/common/Tab/TabList/TabList';
import { useState } from 'react';
import { tableOptions } from '@/constants/option';
import { useGetInfoApi } from '@/api/notice';
import dayjs from 'dayjs';
import useDebounce from '@/hooks/useDebounce';
import { convertInfoValue } from '@/utils/convertValue';
import { generateColumns } from '@/constants/table';

const InfoPlace = () => {
	const navigate = useNavigate();
	const isMoble = useIsMobile(900);
	const location = useLocation();

	const params = location.state?.menu ?? '소식지';
	const [search, setSearch] = useState('');
	const [page, setPage] = useState(1);
	const [selectedOption, setSelectedOption] = useState('전체');
	const [selectedRow, setSelectedRow] = useState(10);
	const debouncedSearch = useDebounce(search, 300);

	const { data: infoData } = useGetInfoApi({
		page: page,
		search: debouncedSearch,
		search_category: selectedOption,
		row: selectedRow,
		type: 'newsletter',
	});

	const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value);
	};
	const handleGetPk = (pk: number | string) => {
		navigate(`/infoplace/detail/${pk}`, { state: { menu: params } });
	};
	const handleClickOption = (menu: string) => {
		setPage(1);
		setSearch('');
		navigate('/infoplace', { state: { menu: menu } });
	};

	const getDynamicField = (g: any, field: string) => {
		const type = 'newsletter';

		return g[`${type}_${field}`] || ''; // 동적으로 필드 처리
	};

	return (
		<main>
			<SubBanner subTitle="News" title="회사의 주요 활동과 투자 관련 최신 소식을 공유합니다." img={infoBanner} />
			<S.ConferenceContainer>
				<S.ConferenceTitle>
						<>
							타이키파트너스 소식
							<br style={isMoble ? {} : { display: 'none' }} />
						</>
				</S.ConferenceTitle>

				<S.ConferenceBoardBox>
					<S.ConferenceSearchBox>
						{/* <InputSelect options={tableOptions} selectedOption={selectedOption} setSelectedOption={setSelectedOption} /> */}
						<InputSelect options={tableOptions} selectedOption={selectedRow} setSelectedOption={value => setSelectedRow(Number(value))} />
						{/* <InputSearch value={search} input={handleSearch} placeholder="검색어 입력" /> */}
					</S.ConferenceSearchBox>
					{infoData && infoData['newsletter']?.length !== 0 ? (
							!isMoble ? (
								<TablePagination activePage={page} totalItems={infoData?.[`newsletter_count`]} onChange={(page) => setPage(page)}>
									<BoardTable
										columns={generateColumns(infoData['newsletter'] ?? [])}
										page={page}
										data={infoData['newsletter'] ?? []}
										totalItems={infoData?.[`newsletter_count`]}
										onClick={handleGetPk}
									/>
								</TablePagination>
							) : (
								<TablePagination activePage={page} totalItems={infoData?.[`newsletter_count`]} onChange={(page) => setPage(page)}>
									<ConferenceList data={infoData['newsletter'] ?? []} sort={'newsletter'} />
								</TablePagination>
							)
					) : (
						<S.EmptyData>해당 데이터가 없습니다.</S.EmptyData>
					)}
				</S.ConferenceBoardBox>
			</S.ConferenceContainer>
		</main>
	);
};

export default InfoPlace;
